export type BoardHistoryShortcut = 'undo' | 'redo' | null;

interface BoardHistoryKeyboardEvent {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}

export function isEditableBoardHistoryTarget(target: EventTarget | null): boolean {
  const element = target as HTMLElement | null;
  return element?.matches('input, textarea, select, [contenteditable="true"]') ?? false;
}

export function getBoardHistoryShortcut(
  event: BoardHistoryKeyboardEvent,
  options: { canvasHovered: boolean; overlayOpen: boolean; target: EventTarget | null },
): BoardHistoryShortcut {
  if (
    !options.canvasHovered ||
    options.overlayOpen ||
    isEditableBoardHistoryTarget(options.target) ||
    event.altKey ||
    !(event.metaKey || event.ctrlKey)
  )
    return null;

  const key = event.key.toLowerCase();
  if (key === 'z' && !event.shiftKey) return 'undo';
  if ((key === 'z' && event.shiftKey) || (key === 'y' && event.ctrlKey && !event.metaKey))
    return 'redo';
  return null;
}
